import { render, staticRenderFns } from "./TheCartResultMini.vue?vue&type=template&id=2226bc2e&"
import script from "./TheCartResultMini.vue?vue&type=script&lang=js&"
export * from "./TheCartResultMini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports